import React, { useState, useEffect } from 'react'
import API_URL from '../common/Apiurl';
import { Link, useNavigate  } from "react-router-dom"
import SuccessMessage from '../common/Message';

function Enteremail(){
    const apiUrl = API_URL;
    const [successMessages, setSuccessMessages] = useState([]);
    const navigate  = useNavigate();
    const postemail = async (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        const getEmailval = data.get('emailId')
        const emailData = {
            emailId: getEmailval
        }
        const sendEmail = await fetch(`${apiUrl}/admin/sendOtp`,{
            method: 'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(emailData)
        })
        const getData = await sendEmail.json()
        console.log(getData)
        if(getData.status === 200){
            localStorage.setItem("userEmail",getEmailval)
            const newSuccessMessage = getData.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
            navigate('/verifyotp')
        }else if(getData.status !== 200){
            const newSuccessMessage = getData.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
    }
    return(
        <>
            <form className="resetForm col-sm-6 mx-auto" onSubmit={postemail}>
                <h1 className="mt-5">Enter Your Email-Id</h1>
                    <div className="formcontainer">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <input type="hidden" name="id" value="" />
                                    <label htmlFor="text"><strong>Email-Id</strong></label>
                                    <input type="text" name="emailId" placeholder="Email Address" required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-5">
                                <input className="button" type="submit" />
                            </div>
                        </div>                        
                    </div>
                    {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )}
            </form>
        </>
    )
}

export default Enteremail;